import Close from '@mui/icons-material/Close';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';
import { useUpdateAffiliateKey } from './hooks';

const ChangeAffiliateKey = ({
  existingAffiliateKey,
  onModalClose,
}: {
  existingAffiliateKey: string;
  onModalClose: () => void;
}) => {
  const [affiliateKey, setAffiliateKey] = useState<string>(existingAffiliateKey || '');

  const {
    isUpdateAffiliateKeyLoading,
    updateAffiliateKeyError,
    setUpdateAffiliateKeyError,
    updateAffiliateKey,
  } = useUpdateAffiliateKey();

  return (
    <Modal open={true} onClose={onModalClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'clamp(250px, 50vh, 500px)',
          width: 'clamp(300px, 50vw, 500px)',
          outline: 'none',
          border: 'none',
          gap: 4,
        }}
      >
        <Typography variant="h6">Change Affiliate Key</Typography>
        <TextField
          fullWidth
          label="Affiliate Key"
          value={affiliateKey}
          error={!!updateAffiliateKeyError}
          onChange={e => setAffiliateKey(e.target.value)}
        />
        <Button
          variant="contained"
          fullWidth
          onClick={() => updateAffiliateKey(affiliateKey)}
          sx={{ background: COLOR_PRIMARY_2, color: 'white' }}
          disabled={isUpdateAffiliateKeyLoading}
        >
          {isUpdateAffiliateKeyLoading ? <CircularProgress size={20} /> : 'Update'}
        </Button>

        {updateAffiliateKeyError && (
          <Alert severity="error" onClose={() => setUpdateAffiliateKeyError('')}>
            <Typography variant="body2">{updateAffiliateKeyError}</Typography>
          </Alert>
        )}

        <IconButton
          sx={{ position: 'absolute', top: 2, right: 2 }}
          size="small"
          onClick={onModalClose}
        >
          <Close />
        </IconButton>
      </Box>
    </Modal>
  );
};

export default ChangeAffiliateKey;
